import React, { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { Logo } from "./Logo";

const LINKS = [
  { href: "#sobre", label: "Sobre" },
  { href: "#anos", label: "20 anos" },
  { href: "#servicos", label: "Serviços" },
  { href: "#diferenciais", label: "Diferenciais" },
  { href: "#cases", label: "Cases" },
  { href: "#executados", label: "Executados" },
  { href: "#segmentos", label: "Segmentos" },
  { href: "#atendimento", label: "Atendimento" },
  { href: "#contato", label: "Contato" },
  { href: "#carreiras", label: "Trabalhe" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-black/85 backdrop-blur-xl border-b border-white/10"
          : "bg-gradient-to-b from-black/70 to-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 h-16 sm:h-20 flex items-center justify-between">
        <Logo size="md" />

        <nav className="hidden lg:flex items-center gap-1">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              className="font-condensed uppercase text-[13px] tracking-[0.18em] text-white/70 hover:text-white px-4 py-2 transition-colors relative group"
            >
              {l.label}
              <span className="absolute left-4 right-4 -bottom-0.5 h-px bg-[#2FA36B] scale-x-0 group-hover:scale-x-100 origin-left transition-transform" />
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#contato"
            data-testid="nav-cta-proposta"
            className="hidden md:inline-flex items-center gap-2 font-condensed uppercase text-[12px] tracking-[0.2em] font-bold bg-[#2FA36B] hover:bg-[#37B87A] text-white px-5 py-3 transition-colors"
          >
            <Phone size={14} strokeWidth={2.5} />
            Solicitar proposta
          </a>

          <button
            type="button"
            aria-label="Abrir menu"
            data-testid="nav-mobile-toggle"
            className="lg:hidden text-white p-2"
            onClick={() => setOpen((v) => !v)}
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-black/95 border-t border-white/10 backdrop-blur-xl">
          <div className="px-5 py-6 flex flex-col gap-1">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-link-${l.href.replace("#", "")}`}
                className="font-condensed uppercase text-sm tracking-[0.2em] text-white/80 hover:text-[#2FA36B] py-3 border-b border-white/5"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contato"
              onClick={() => setOpen(false)}
              data-testid="mobile-cta-proposta"
              className="mt-4 inline-flex items-center justify-center font-condensed uppercase text-sm tracking-[0.2em] font-bold bg-[#2FA36B] text-white px-5 py-4"
            >
              Solicitar proposta
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
